/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Error_TitleInputs */

const en_offline_error_title = /** @type {(inputs: Offline_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service Unavailable`)
};

const fr_offline_error_title = /** @type {(inputs: Offline_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service Indisponible`)
};

const de_offline_error_title = /** @type {(inputs: Offline_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienst nicht verfügbar`)
};

const it_offline_error_title = /** @type {(inputs: Offline_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servizio non disponibile`)
};

const ru_offline_error_title = /** @type {(inputs: Offline_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сервис недоступен`)
};

const es_offline_error_title = /** @type {(inputs: Offline_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servicio No Disponible`)
};

const zh_cn2_offline_error_title = /** @type {(inputs: Offline_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂停服务`)
};

const ja_offline_error_title = /** @type {(inputs: Offline_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービスは利用できません`)
};

const hi_offline_error_title = /** @type {(inputs: Offline_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेवा अनुपलब्ध है`)
};

const pt_pt2_offline_error_title = /** @type {(inputs: Offline_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serviço não disponível`)
};

/**
* | output |
* | --- |
* | "Service Unavailable" |
*
* @param {Offline_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_error_title = /** @type {((inputs?: Offline_Error_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Error_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_error_title(inputs)
	if (locale === "de") return de_offline_error_title(inputs)
	if (locale === "it") return it_offline_error_title(inputs)
	if (locale === "ru") return ru_offline_error_title(inputs)
	if (locale === "es") return es_offline_error_title(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_error_title(inputs)
	if (locale === "ja") return ja_offline_error_title(inputs)
	if (locale === "hi") return hi_offline_error_title(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_error_title(inputs)
	return en_offline_error_title(inputs)
});